
export default {
  wechatKey : '__xr_wechatinfo',
  openIdKey : '__xr_wechatopenid',

  //微信信息
  addWeChatInfo : function(us){
    this.delWeChatInfo()
    if(typeof(us) == Object){
      us = JSON.stringify(us)
    }
    window.localStorage.setItem(this.wechatKey, us)
  },
  updateWeChatInfo : function(us){
    this.addWeChatInfo(us)
  },
  getWeChatInfo : function(){
    return window.localStorage.getItem(this.wechatKey)
  },
  delWeChatInfo : function(){
    return window.localStorage.removeItem(this.wechatKey)
  },
  //微信openid
  addOpenId : function(us){
    this.delOpenId()
    if(typeof(us) == Object){
      us = JSON.stringify(us)
    }
    window.localStorage.setItem(this.openIdKey, us)
  },
  updateOpenId : function(us){
    this.addOpenId(us)
  },
  getOpenId : function(){
    return window.localStorage.getItem(this.openIdKey)
  },
  delOpenId : function(){
    return window.localStorage.removeItem(this.openIdKey)
  }
}



// WEBPACK FOOTER //
// ./src/util/wechatCache.js